import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Route, Redirect, Switch } from 'react-router-dom';
import axios from 'axios';

import Navbar from './components/Navbar';
import UploadAd from './UploadAd';
import Display from './Display';
import AdSettings from './AdSettings';
import AllDone from './AllDone';

const COMPONENTS = {
  'upload-ad': UploadAd,
  'display-1': Display,
  'display-2': Display,
  'display-3': Display,
  'display-4': Display,
  'ad-settings': AdSettings,
  'all-done': AllDone,
};

const stepPages = [
  { path: 'upload-ad', label: 'upload ad', valid: false },
  {
    path: 'display-1', label: 'display 1', contentWidth: 2048, contentHeight: 1536, valid: true, preview: true, title: 'iPad Mini: retina display',
  },
  {
    path: 'display-2', label: 'display 2', contentWidth: 1024, contentHeight: 768, valid: true, preview: true, title: 'iPad Mini: non-retina display',
  },
  {
    path: 'display-3', label: 'display 3', contentWidth: 2048, contentHeight: 1536, valid: true, preview: true, title: 'Full-size iPad: retina display',
  },
  {
    path: 'display-4', label: 'display 4', contentWidth: 1024, contentHeight: 768, valid: true, preview: true, title: 'Full-size iPad: non-retina display',
  },
  { path: 'ad-settings', label: 'ad settings', valid: false },
  { path: 'all-done' },
];

export default class Upload extends Component {
  constructor(props) {
    super(props);

    this.state = {
      steps: stepPages,
      currentIndex: 0,
      signedUrl: '',
      previewOnly: false,
      htmlSrc: '',
      fileFormat: ''
    };
  }

  componentDidMount() {
    const { match } = this.props;
    if (match && match.params.adId) {
      /* eslint-disable-next-line */
      const adId = match.params.adId;
      const endpoint = `/api/ad-preview/${adId}`;
      axios.get(endpoint)
        .then(async (res) => {
          if (res.status === 200 && res.data) {
            const { signedUrl, fileFormat, html } = res.data;

            this.setState({
              adId,
              signedUrl,
              previewOnly: true,
              /* eslint-disable-next-line */
              steps: this.state.steps.filter(s => s.preview),
              htmlSrc: html,
              fileFormat,
            });
          } else {
            /* eslint-disable-next-line */
            alert('Error encountered');
          }
        })
        .catch((err) => {
          console.log(err);
          /* eslint-disable-next-line */
          alert('Error encountered');
        });
    }
  }

  componentWillUpdate(props) {
    const { location } = props;
    if (location.pathname === '/upload') {
      window.location.href = '/upload';
    }
  }

  /* eslint-disable-next-line */
  onNext = () => {
    /* eslint-disable-next-line */
    const { currentIndex, steps, adId, previewOnly } = this.state;
    const { history } = this.props;
    const baseUrl = previewOnly ? `/preview/${adId}` : '/upload';

    if (currentIndex + 1 < steps.length) {
      if (steps[currentIndex].onNext) {
        return steps[currentIndex].onNext(() => {
          const url = `${baseUrl}/${steps[currentIndex + 1].path}`;
          history.push(url);
        });
      }

      const url = `${baseUrl}/${steps[currentIndex + 1].path}`;
      history.push(url);
    } else if (previewOnly) {
      history.push('/');
    }
  }

  onNavigate = (currentIndex) => {
    this.setState({ currentIndex });
  }

  setSignedUrl = async (signedUrl, adId, fileFormat, html) => {
    this.setState({
      signedUrl,
      adId,
      htmlSrc: html,
      fileFormat
    });
  }

  modifyStep = (index) => {
    const { steps } = this.state;

    const stepsSlice = steps.slice();

    return (modifiedStep) => {
      Object.assign(stepsSlice[index], modifiedStep);
      this.setState({
        steps: stepsSlice,
      });
    };
  }

  render() {
    const {
      currentIndex, signedUrl, steps, adId, previewOnly, htmlSrc, fileFormat
    } = this.state;

    const { history } = this.props;
    const baseUrl = previewOnly ? `/preview/${adId}` : '/upload';
    // console.log('baseUrl', baseUrl);

    return (
      <Container>
        <Navbar
          steps={steps}
          currentIndex={currentIndex}
          onNext={this.onNext}
          history={history}
          valid={steps[currentIndex].valid}
          baseUrl={baseUrl}
          previewOnly={previewOnly}
        />
        <div>
          <Switch>
            {
              previewOnly ? (
                /* eslint-disable-next-line */
                <Redirect exact from={baseUrl} to={`${baseUrl}/display-1`} />
              ) : (
                <Redirect exact from={baseUrl} to="/upload/upload-ad" />
              )
            }
            {steps.map((step, key) => (
              <Route
                /* eslint-disable-next-line */
                key={key}
                path={`${baseUrl}/${step.path}`}
                render={() => {
                  if (key !== currentIndex) this.onNavigate(key);
                  const CurrentComponent = COMPONENTS[step.path];
                  return (
                    <CurrentComponent
                      history={history}
                      title={step.title}
                      contentWidth={step.contentWidth}
                      contentHeight={step.contentHeight}
                      signedUrl={signedUrl}
                      adId={adId}
                      setSignedUrl={this.setSignedUrl}
                      modifyStep={this.modifyStep(currentIndex)}
                      firstStepValid={steps[0].valid}
                      previewOnly={previewOnly}
                      html={htmlSrc}
                      fileFormat={fileFormat}
                    />
                  );
                }}
              />
            ))}
          </Switch>
        </div>
      </Container>
    );
  }
}

Upload.propTypes = {
  // steps: PropTypes.arrayOf(PropTypes.object).isRequired,
  // currentIndex: PropTypes.number.isRequired,
  // onNext: PropTypes.func.isRequired,
  /* eslint-disable-next-line */
  history: PropTypes.object.isRequired,
  /* eslint-disable-next-line */
  match: PropTypes.object.isRequired,
  /* eslint-disable-next-line */
  location: PropTypes.object.isRequired,
};

const Container = styled.div`
  max-width: 1200px;
  margin: auto;
`;



// WEBPACK FOOTER //
// ./client/Upload/index.js